import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faGithub,
  faLinkedin
} from "@fortawesome/free-brands-svg-icons";

import {
  faHeart
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faGithub,
  faLinkedin,
  faHeart
);

createApp(App).use(store).use(router).component("font-awesome-icon", FontAwesomeIcon)
.mount("#app");
